import React from 'react';
import TableComponent from '../../../common/TableComponent';
import { noop } from '../../../common/propTypes';
import Map from '../../../map/Map/';
import ErrorBoundary from '../../../common/ErrorBoundary';
import PropTypes from 'prop-types';
import './styles.scss';

function PreviewTable({
    preview,
    totalCount,
    loading,
    columns,
    onPageChange,
    currentPage,
    mapData,
    isMapLoading,
}) {
    return (
        <section className="TableWrapper primary-highlight downloads-table">
            <div className="primary-highlight verticalSpace">
                <div className="container">
                    <ul className="nav nav-tabs" id="myTab" role="tablist">
                        <li className="nav-item">
                            <a
                                className="nav-link active"
                                id="map-tab"
                                data-toggle="tab"
                                href="#map"
                                role="tab"
                                aria-controls="map"
                                aria-selected="true"
                            >
                                <h5 className="modal-title">Map</h5>
                            </a>
                        </li>
                        <li className="nav-item">
                            <a
                                className="nav-link"
                                id="result-tab"
                                data-toggle="tab"
                                href="#result"
                                role="tab"
                                aria-controls="result"
                                aria-selected="false"
                            >
                                <h5 className="modal-title">Report</h5>
                            </a>
                        </li>
                    </ul>
                    <div className="tab-content" id="myTabContent">
                        <div
                            className="tab-pane fade show active"
                            id="map"
                            role="tabpanel"
                            aria-labelledby="map-tab"
                        >
                            {isMapLoading ? (
                                <div className="col-md-12 mt-4">
                                    <div className="content-box card">
                                        <div>{'Loading Map...'}</div>
                                    </div>
                                </div>
                            ) : null}

                            {!isMapLoading && !mapData.length ? (
                                <div className="col-md-12 mt-4">
                                    <div className="content-box card">
                                        <div>{'No Map Data'}</div>
                                    </div>
                                </div>
                            ) : null}

                            {!isMapLoading && mapData.length ? (
                                <div className="col-md-12 mt-4">
                                    <ErrorBoundary>
                                        <p className="info-white">
                                            <em>
                                                Note: Maximum 50,000 litters can
                                                be viewed on map
                                            </em>
                                        </p>
                                        <Map dataPoints={mapData} />
                                    </ErrorBoundary>
                                </div>
                            ) : null}
                        </div>
                        <div
                            className="tab-pane fade"
                            id="result"
                            role="tabpanel"
                            aria-labelledby="result-tab"
                        >
                            <TableComponent
                                rows={preview}
                                subheading={(totalCount || 0).toString()}
                                onClose={noop}
                                columns={columns}
                                rowCount={totalCount}
                                currentPage={currentPage}
                                buttonDisabled={loading}
                                showDownloadBtn={false}
                                showPagination={true}
                                onPageChange={onPageChange}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

PreviewTable.propTypes = {
    preview: PropTypes.array,
    totalCount: PropTypes.number,
    loading: PropTypes.bool,
    columns: PropTypes.array,
    // indicates whether the map data has loaded or not
    isMapLoading: PropTypes.bool,
    onPageChange: PropTypes.func,
    currentPage: PropTypes.number,
    // map pointers to be shown for the current report
    mapData: PropTypes.array,
};

PreviewTable.defaultProps = {
    preview: [],
    totalCount: 2183092,
    mapData: [],
    loading: false,
    columns: [
        { label: 'Litter', key: 'id' },
        { label: 'Tags', key: 'tags' },
        { label: 'Location (Lat / Long)', key: 'location' },
        { label: 'Country', key: 'country' },
        { label: 'Date', key: 'createdAt' },
    ],
    onPageChange: noop,
    currentPage: 1,
    isMapLoading: false,
};
export default PreviewTable;
